import asyncSeries from 'async/series';
import EventEmitter from 'events';

import util from '../tools/util';
import UserStore from './user_store';

export default {
  once,
  addChangeListener,
  removeChangeListener,
  init,
  isReady,
  getList,
  getDevice,
  getVolume,
  fetch,
  fetchDevice,
  fetchVolume,
};

let g_deviceList: any = null;
const g_deviceMap: Map<number, any> = new Map();
const g_volumeMap: Map<string, any> = new Map();

const g_eventEmitter = new EventEmitter();
const CHANGE_EVENT = 'change';
function once(callback) {
  g_eventEmitter.once(CHANGE_EVENT, callback);
}
function addChangeListener(callback) {
  g_eventEmitter.on(CHANGE_EVENT, callback);
}
function removeChangeListener(callback) {
  g_eventEmitter.removeListener(CHANGE_EVENT, callback);
}
function _emit(...args) {
  g_eventEmitter.emit(CHANGE_EVENT, ...args);
}
function init(done) {
  done && done();
}
function isReady() {
  return true;
}
function getList() {
  return g_deviceList;
}
function getDevice(device_id: number) {
  return g_deviceMap.get(device_id);
}
function getVolume(device_id: number, volume_id: number) {
  const key = `${device_id}-${volume_id}`;
  return g_volumeMap.get(key);
}

function fetch(done?: (err: any) => void) {
  const opts = {
    url: `/api/1/device`,
  };
  UserStore.get(opts, (err, body) => {
    if (err) {
      util.errorLog('DeviceStore.fetch: err:', err);
    } else if (body) {
      if (!util.deepEqual(g_deviceList, body.device_list)) {
        g_deviceList = body.device_list;
        _emit('update');
      }
    }
    if (done) {
      done(err);
    }
  });
}

function fetchDevice(device_id: number, done?: (err: any) => void) {
  const opts = {
    url: `/api/1/device/${device_id}`,
  };
  UserStore.get(opts, (err, body) => {
    if (err) {
      util.errorLog('DeviceStore.fetchDevice: err:', err);
    } else if (body) {
      g_deviceMap.set(device_id, body);
      _emit('device');
    }
    if (done) {
      done(err);
    }
  });
}
function fetchVolume(params, done?: (err: any) => void) {
  const { device_id, volume_id } = params;

  const info = {};
  asyncSeries(
    [
      (done) => {
        const opts = {
          url: `/api/1/device/${device_id}/volume/${volume_id}/downloads`,
        };
        UserStore.get(opts, (err, body) => {
          if (err) {
            util.errorLog('DeviceStore.fetchVolume: downloads err:', err);
          } else if (body) {
            info.download_list = body.download_list;
          }
          done(err);
        });
      },
      (done) => {
        const opts = {
          url: `/api/1/device/${device_id}/volume/${volume_id}/uploads`,
        };
        UserStore.get(opts, (err, body) => {
          if (err) {
            util.errorLog('DeviceStore.fetchVolume: uploads err:', err);
          } else if (body) {
            info.upload_list = body.upload_list;
          }
          done(err);
        });
      },
    ],
    (err) => {
      if (!err) {
        const key = `${device_id}-${volume_id}`;
        g_volumeMap.set(key, info);
        _emit('volume');
      }
      if (done) {
        done(err);
      }
    }
  );
}
